import { Route, Routes } from "react-router-dom";
import About from "./Components/About/About";
import Home from "./Components/Home/Home";
import NavBar from "./Components/NavBar/NavBar";
import Works from "./Components/Works/Works";
import Allproducts from "./Components/Works/AllProducts/Allproducts";
import Footer from "./Components/Footer/Footer";
import FrameReact from "./Components/Works/React/FrameReact";
import JavaScript from "./Components/Works/JavaScipt/JavaScript";
import HtmlCss from "./Components/Works/HtmlCss/HtmlCss";
import { useRef } from "react";
import FullStack from "./Components/Works/FullStack/FullStack";
import Certificate from "./Components/Certificate/Certificate";
import SingalCerificate from "./Components/Certificate/SingalCerificate";

function App() {
  const about = useRef(null);
  return (
    <div className="App">
      <NavBar  ref={about} />
      <Home />
      <About ref={about} /> 
      <Routes>
        <Route
          path="/"
          element={<Works  />}
          children={<Route path="/" element={<Allproducts />} />}
        />
        <Route
          path="/"
          element={<Works/>}
          children={<Route path="/css" element={<HtmlCss />} />}
        />
        <Route
          path="/"
          element={<Works />}
          children={<Route path="/native" element={<JavaScript />} />}
        />
        <Route
          path="/"
          element={<Works />}
          children={<Route path="/react" element={<FrameReact />} />}
        />
        <Route
          path="/"
          element={<Works />}
          children={<Route path="/fullstack" element={<FullStack />} />}
        />
        <Route path="/:id" element={<SingalCerificate />}/>
      </Routes>
      <Certificate />
      
      <Footer />
    </div>
  );
}

export default App;
